import Cookies from 'js-cookie';

export const isOpenBetSessionProxyModeEnabled = () => {
  return typeof Cookies.get('wh-ob-session-proxy-mode-enabled') !== 'undefined';
};
